export default "__VITE_ASSET__99c382c1__"